import { ethers } from "ethers";
import React, { createContext, useContext, useEffect, useState } from "react";
import { kitty_contract_address } from "../contracts/addresses";
import { _ZombieContract } from "../contracts/Zombie";
import { IzombieData } from "../interfaces/games/izombie";
import { decimals } from "../utils/constant";
import { generateRandomNumber } from "../utils/helper";

import { useGlobal } from "./GlobalContext";
import { useAccount } from "./WalletContext";

interface ZombieNode {
	createRandomZombie: Function;
	my_zombies: IzombieData[];
	enemies: IzombieData[];
	feedZombie: (zombie_id: number, kitty_id: number) => void;
	changeName: (zombie_id: number, new_name: string) => void;
	getEnemies: (level: number) => void;
	attack: (zombie_id: number, target_id: number) => void;
}
const ZombieContext = createContext({} as ZombieNode);

interface Props { }
export const ZombieProvider: React.FC<Props> = ({ children }) => {
	const ZombieContract = _ZombieContract();
	const { setIsProcessing } = useGlobal();
	const { currentAccount } = useAccount();

	const [my_zombies, setMyZombies] = useState<any>();
	const [enemies, setEnemies] = useState<any>();

	const createRandomZombie = async () => {
		setIsProcessing(true);
		try {
			if (ZombieContract) {
				const tx = await ZombieContract.createRandomZombie("No Name", {
					from: currentAccount,
					gasLimit: 300000,
				});
				console.log("creating zombies start");
				await tx.wait();
				console.log("creating zombies finish");
				getMyZombies();
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
		}
	};

	const getMyZombies = (account_address?: string) => {
		setIsProcessing(true);
		if (ZombieContract && currentAccount) {
			ZombieContract.getZombiesByOwner(currentAccount).then(
				(zombies: any[]) => {
					const _zombies = zombies.map((_zombie) => {
						const { id, dna, name, level, readyTime, winCount, loseCount } =
							_zombie;
						return {
							id: Number(ethers.utils.formatEther(id)) * decimals,
							dna: `${Number(ethers.utils.formatEther(dna)) * decimals}`,
							name,
							level,
							readyTime,
							winCount,
							loseCount,
						};
					});
					setMyZombies(_zombies);
					setIsProcessing(false);
				}
			);
		}
	};

	const feedZombie = async (zombie_id: number, kitty_id: number) => {
		// console.log({ zombie_id, kitty_id });
		// console.log(typeof zombie_id);
		// console.log(typeof kitty_id);

		try {
			setIsProcessing(true);
			if (ZombieContract) {
				const tx = await ZombieContract.feedOnKitty(
					zombie_id,
					// generateRandomNumber(99),
					`${kitty_id}`,
					{
						from: currentAccount,
						gasLimit: 300000,
					}
				);
				console.log("feeding zombies start");
				// console.log({ currentAccount, zombie_id, kitty_id });

				await tx.wait();
				console.log("feeding zombies finish");
			}
		} catch (e) {
			console.error(e);
		} finally {
			history.back();
			getMyZombies();
			setIsProcessing(false);
		}
	};

	const getEnemies = (zombie_lv: number) => {
		setIsProcessing(true);
		if (ZombieContract) {
			ZombieContract.getEnemies(zombie_lv).then((zombies: any[]) => {
				const _zombies = zombies
					?.filter((zombie) => zombie.dna != 0)
					?.map((_zombie) => {
						const { id, dna, name, level, readyTime, winCount, loseCount } =
							_zombie;
						return {
							id: Number(ethers.utils.formatEther(id)) * decimals,
							dna: `${Number(ethers.utils.formatEther(dna)) * decimals}`,
							name,
							level,
							readyTime,
							winCount,
							loseCount,
						};
					});
				setEnemies(_zombies);
				setIsProcessing(false);
			});
		}
	};

	const attack = async (zombie_id: number, target_id: number) => {
		try {
			setIsProcessing(true);
			if (ZombieContract) {
				const tx = await ZombieContract.attack(zombie_id, target_id, {
					from: currentAccount,
					gasLimit: 300000,
				});
				console.log("feeding zombies start");
				await tx.wait();
				console.log("feeding zombies finish");
			}
		} catch (e) {
			console.error(e);
		} finally {
			history.back();
			getMyZombies();
			setIsProcessing(false);
		}
	};

	const changeName = async (zombie_id: number, new_name: string) => {
		// console.log(typeof zombie_id, typeof new_name);

		setIsProcessing(true);
		try {
			if (ZombieContract) {
				const tx = await ZombieContract.changeName(zombie_id, new_name, {
					from: currentAccount,
					gasLimit: 300000,
				});
				console.log("change name zombies start");
				await tx.wait();
				console.log("change name zombies finish");
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
			getMyZombies();
		}
	};

	// const setKittyContract = () => {
	// 	setIsProcessing(true);
	// 	try {
	// 		if (ZombieContract) {
	// 			console.log("setKittyContract address start");
	// 			ZombieContract.setKittyContractAddress(kitty_contract_address, {
	// 				from: currentAccount,
	// 				gasLimit: 300000,
	// 			}).then((tx: any) => {
	// 				tx.wait().then((_: any) => {
	// 					console.log("setKittyContract address finish");
	// 				});
	// 			});
	// 		}
	// 	} catch (e) {
	// 		console.error(e);
	// 	} finally {
	// 		setIsProcessing(false);
	// 	}
	// };
	// useEffect(setKittyContract, []);

	useEffect(() => {
		getMyZombies();
	}, [currentAccount]);

	// console.log({ my_zombies, enemies });


	return (
		<ZombieContext.Provider
			value={{
				createRandomZombie,
				my_zombies,
				feedZombie,
				changeName,
				enemies,
				getEnemies,
				attack,
			}}
		>
			{children}
		</ZombieContext.Provider>
	);
};

export const useZombie = () => useContext(ZombieContext);
